import { cx } from '@linaria/core';
import { InfoError } from '../Text/Information.jsx';

const ErrorMessage = ({ className, error: { message } }) => (
  <div className={cx(className, 'container error')}>
    <InfoError>{message}</InfoError>
  </div>
);
export const StyledErrorMessage = ErrorMessage;
